module.exports = __webpack_public_path__ + "img/memoir_rings.97625bd.jpg";